import React from 'react';
import * as _ from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';
import { TimeConverter } from 'utility/time-converter';
import { AnalyticsHelpers } from '../../analytics.helpers';
import './usage-highlights-block.scss';
export const UsageHighlightsBlock = ({ data, monthName }) => {
    const intl = useIntl();
    const cn = AnalyticsHelpers.makeAnalyticsClass('usage');
    const ifGrowthInPercentPositive = (percent) => {
        if (percent > 0) {
            return (<span>
          &nbsp;(<span className={cn('percent')}>+{Math.round(percent)}%</span>)
        </span>);
        }
        return '';
    };
    const translateMonth = (date) => {
        if (date) {
            let month = date.replace(/[0-9]/g, '').trim();
            let year = ' ' + date.replace(/\D/g, '').trim();
            return (<span>
          ({intl.formatMessage({ id: `account.analytics.months.${month}` }) + year})
        </span>);
        }
        return '';
    };
    return (<div>
      <h4 className={cn('title')}><FormattedMessage id="account.analytics.usage.usage-highlights-block.title"/></h4>
      <div className={cn('table')}>
        <dl className={cn('row')}>
          <dt className={cn('key')}><FormattedMessage id="account.analytics.usage.usage-highlights-block.average-sessions-per-month"/></dt>
          <dd className={cn('value')}>{AnalyticsHelpers.formatNumber(data.averageSessions)}</dd>
        </dl>
        <dl className={cn('row')}>
          <dt className={cn('key')}>{monthName} <FormattedMessage id="account.analytics.usage.usage-highlights-block.sessions-this-month"/></dt>
          <dd className={cn('value')}>
            {_.isEmpty(data.dataByDate)
            ? 0
            : AnalyticsHelpers.formatNumber(_.last(data.dataByDate).totalSessionPerMonth)}
            {ifGrowthInPercentPositive(data.growthInPercent)}
          </dd>
        </dl>
        <dl className={cn('row')}>
          <dt className={cn('key')}>
            <FormattedMessage id="account.analytics.usage.usage-highlights-block.most-sessions-in-month"/>
            {Boolean(data.maxSessionsInMonth)
            ? translateMonth(data.maxSessionsInMonth.date)
            : ''}
          </dt>
          <dd className={cn('value')}>
            {Boolean(data.maxSessionsInMonth)
            ? AnalyticsHelpers.formatNumber(data.maxSessionsInMonth.totalSessionPerMonth)
            : 0}
          </dd>
        </dl>
        <dl className={cn('row')}>
          <dt className={cn('key')}>
            <FormattedMessage id={TimeConverter.millisecondsToMinutes(Boolean(data.maxDurationInMonth)
            ? data.maxDurationInMonth.totalDurationPerMonth
            : {}) === 1
            ? 'account.analytics.usage.usage-highlights-block.most-minute-in-month'
            : 'account.analytics.usage.usage-highlights-block.most-minutes-in-month'}/>{' '}
            {Boolean(data.maxDurationInMonth)
            ? translateMonth(data.maxDurationInMonth.date)
            : ''}
          </dt>
          <dd className={cn('value')}>
            {!Number.isNaN(TimeConverter.millisecondsToMinutes(Boolean(data.maxDurationInMonth)
            ? data.maxDurationInMonth.totalDurationPerMonth
            : {}))
            ? AnalyticsHelpers.formatNumber(TimeConverter.millisecondsToMinutes(Boolean(data.maxDurationInMonth)
                ? data.maxDurationInMonth.totalDurationPerMonth
                : {}))
            : 0}
          </dd>
        </dl>
        <dl className={cn('row')}>
          <dt className={cn('key')}><FormattedMessage id="account.analytics.usage.usage-highlights-block.total-session-all-time"/></dt>
          <dd className={cn('value')}>{AnalyticsHelpers.formatNumber(data.totalSession)}</dd>
        </dl>
        <dl className={cn('row')}>
          <dt className={cn('key')}><FormattedMessage id={(TimeConverter.millisecondsToMinutes(data.totalDuration)) === 1 ?
            'account.analytics.usage.usage-highlights-block.total-minute-all-time' :
            'account.analytics.usage.usage-highlights-block.total-minutes-all-time'}/></dt>
          <dd className={cn('value')}>{AnalyticsHelpers.formatNumber(TimeConverter.millisecondsToMinutes(data.totalDuration))}</dd>
        </dl>
      </div>
    </div>);
};
